import * as React from 'react';
import {
    Edit,
    FileField,
    FileInput,
    SelectInput,
    SimpleForm,
    TextInput,
    useRecordContext,
} from 'react-admin';
import { Box, Typography } from '@mui/material';
import { WrappedWithBackButton } from '../common/wrapped-with-back-button';
import { documentTypes } from './document-list';
import { useTheme } from '@mui/material/styles';

const DocumentForm = () => {
    const record = useRecordContext();
    const theme = useTheme();

    return (
        <SimpleForm>
            <TextInput source="name" label={'Név'} name={'name'} required />
            <SelectInput
                defaultValue={'Unique'}
                source="type"
                label={'Típus'}
                choices={documentTypes}
                readOnly
                sx={{ display: 'none' }}
            />
            {record && record.hasOwnProperty('url') && (
                <Box sx={{ marginBottom: '10px' }}>
                    <Typography
                        sx={{
                            fontSize: '0.75em',
                            marginBottom: '0.2em',
                        }}
                    >
                        Jelenlegi fájl
                    </Typography>
                    <a
                        href={record.url}
                        target={'_blank'}
                        style={{
                            color:
                                theme.palette.mode === 'dark'
                                    ? theme.palette.primary['400']
                                    : theme.palette.primary.main,
                        }}
                    >
                        {record.url}
                    </a>
                </Box>
            )}
            <FileInput source="file" name={'file'}>
                <FileField source="src" title="Fájl" />
            </FileInput>
        </SimpleForm>
    );
};

export const DocumentEdit = () => (
    <WrappedWithBackButton>
        <Edit title={'Nyomtatvány szerkesztése'}>
            <DocumentForm />
        </Edit>
    </WrappedWithBackButton>
);
